/**
 * BubbleButton Component
 * Clickable bubble-style button for user quick replies
 */

import React from 'react';
import './BubbleButton.css';

export interface BubbleButtonProps {
  /** Button label text */
  label: string;
  /** Optional icon or emoji */
  icon?: string;
  /** Click handler */
  onClick: () => void;
  /** Disabled state */
  disabled?: boolean;
  /** Custom className */
  className?: string;
  /** Visual style variant */
  variant?: 'default' | 'cta';
  /** Optional flag to mark this as a CTA button for tracking classes */
  isCTA?: boolean;
}

export const BubbleButton: React.FC<BubbleButtonProps> = ({
  label,
  icon,
  onClick,
  disabled = false,
  className = '',
  variant = 'default',
  isCTA = false,
}) => {
  const handleClick = () => {
    if (disabled) return;
    onClick();
  };

  const buttonClass = `bubble-button ${disabled ? 'bubble-button--disabled' : ''} ${variant === 'cta' ? 'bubble-button--cta' : ''} ${isCTA ? 'cta_click' : ''} ${className}`;

  return (
    <button
      className={buttonClass}
      onClick={handleClick}
      disabled={disabled}
      type="button"
      aria-label={label}
    >
      {icon && <span className="bubble-button__icon">{icon}</span>}
      <span className="bubble-button__label">{label}</span>
    </button>
  );
};

export default BubbleButton;
